// src/pages/AdvanceCreditor/components/exportAdvanceCreditorCsv.js
import commaNumber from "comma-number";

const format = commaNumber.bindWith(",", ".");
const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};
const fmtNum = (val) => format(parseFloat(val || 0).toFixed(2));

/**
 * @param {object} params
 * @param {Array}   params.list    - from Redux state.advanceCreditor.list
 * @param {object}  params.totals  - from Redux state.advanceCreditor.totals
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportAdvanceCreditorCsv = ({
  list,
  totals,
  title    = "Advance Creditor/Supplier Balance Report",
  filename = "advance_creditor_balance",
}) => {
  const headers = [
    "No.", "Creditor Name", "Contact No", "Address",
    "Received", "Payment", "Balance",
  ].map(escape);

  const dataRows = list.map((row, i) => [
    i + 1,
    row.acc_name   || "",
    row.contact_no || "",
    row.address    || "",
    fmtNum(row.rcv_amount),
    fmtNum(row.pay_amount),
    fmtNum(row.balance),
  ].map(escape));

  const totalRow = [
    "Grand Total:", "", "", "",
    fmtNum(totals.received),
    fmtNum(totals.payment),
    fmtNum(totals.balance),
  ].map(escape);

  const rows = [[title], [], headers, ...dataRows, [], totalRow];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};